import { render, staticRenderFns } from "./shipCard.vue?vue&type=template&id=62324cb0&scoped=true&"
import script from "./shipCard.vue?vue&type=script&lang=js&"
export * from "./shipCard.vue?vue&type=script&lang=js&"
import style0 from "./shipCard.vue?vue&type=style&index=0&id=62324cb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62324cb0",
  null
  
)

export default component.exports